var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('ignore-web-orders',{ref:"ignoreWebOrders",attrs:{"ignore-web-orders":_vm.ignoreWebOrders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }